import React from 'react'
import { Grid } from 'semantic-ui-react'

import { GridContainer } from 'shared/StyledComponents'

const Layout = ({ children, wrappedCmpsShareOfWidth }) => (
  <GridContainer>
    <Grid>
      <Grid.Row>
        <Grid.Column width={16 - wrappedCmpsShareOfWidth} verticalAlign="middle">
          {children[0]}
        </Grid.Column>

        <Grid.Column width={wrappedCmpsShareOfWidth}>{children[1]}</Grid.Column>
      </Grid.Row>
    </Grid>
  </GridContainer>
)

export default Layout
